import { render, staticRenderFns } from "./waitauditcustomerlist.vue?vue&type=template&id=32694fec&"
import script from "./waitauditcustomerlist.vue?vue&type=script&lang=js&"
export * from "./waitauditcustomerlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports